import { DealOperationCategory } from './deal-operation-categories';

export enum DealOperationSubcategory {
  TertiaryIndustrial = 'industrial',
  TertiaryCommercial = 'commercial',
  TertiaryOffice = 'office',
  TertiaryHotel = 'hotel',
  TertiaryParking = 'parking',

  Residential = 'residential',

  Ground = 'ground',

  Debt = 'debt'
}

export interface DealOperationSubcategoryData {
  label: string;
  category: DealOperationCategory;
  value: DealOperationSubcategory;
}

export const DealOperationSubcategoriesArray = [
  {
    label: 'Nave',
    category: DealOperationCategory.Tertiary,
    value: DealOperationSubcategory.TertiaryIndustrial,
  },
  {
    label: 'Local',
    category: DealOperationCategory.Tertiary,
    value: DealOperationSubcategory.TertiaryCommercial,
  },
  {
    label: 'Oficina',
    category: DealOperationCategory.Tertiary,
    value: DealOperationSubcategory.TertiaryOffice,
  },
  {
    label: 'Hotelero',
    category: DealOperationCategory.Tertiary,
    value: DealOperationSubcategory.TertiaryHotel,
  },
  {
    label: 'Aparcamiento',
    category: DealOperationCategory.Tertiary,
    value: DealOperationSubcategory.TertiaryParking,
  },

  {
    label: 'Residencial',
    category: DealOperationCategory.Residential,
    value: DealOperationSubcategory.Residential,
  },

  {
    label: 'Suelo',
    category: DealOperationCategory.Ground,
    value: DealOperationSubcategory.Ground,
  },

  {
    label: 'Deuda',
    category: DealOperationCategory.Debt,
    value: DealOperationSubcategory.Debt,
  },
];
